/** @jsxImportSource @emotion/react */
import { useGetUserOrders } from "../../../../service/api";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import * as authSelectors from "../../../auth/authSelectors";
import { UserOrdersList } from "./UserOrdersList";
import { useSelector } from "react-redux";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../../style-util";
import { useHandleFetchError } from "../../../../error-handler";

type Props = {
  userId: string;
};

export const UserOrders = ({ userId }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const { data: orders, isLoading, error } = useGetUserOrders(
    organizationKeyName,
    userId
  );

  useHandleFetchError(error);

  if (error && !isLoading) {
    return null;
  }

  return (
    <CardContainer>
      <PageHeader title="10 latest orders" />
      <CardBody css={cardBottomPadding}>
        <UserOrdersList isLoading={isLoading} orders={orders} />
      </CardBody>
    </CardContainer>
  );
};
